module.exports = __webpack_public_path__ + "static/media/wordmark.b75565ae.svg";